import React from 'react';
import { IconPlus, IconList, IconWallet, IconUsers } from './Icons';
import { useI18n } from '../../services/i18n';

export default function TabBar({ activeTab, onTabChange }) {
  const { t } = useI18n();

  const TABS = [
    { id: 'order', label: t('tab_order'), icon: <IconPlus /> },
    { id: 'orders', label: t('tab_orders'), icon: <IconList /> },
    { id: 'wallet', label: t('tab_wallet'), icon: <IconWallet /> },
    { id: 'referral', label: t('tab_referral'), icon: <IconUsers /> },
  ];

  return (
    <nav className="tabbar" data-testid="tabbar">
      {TABS.map((tab) => {
        const isOn = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            className={`tab ${isOn ? 'is-on' : ''}`}
            onClick={() => onTabChange(tab.id)}
            data-testid={`tab-${tab.id}`}
          >
            {tab.icon}
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
}
